import { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const PCMAWrapperStyles = css`
  &.pcma-hero {
    display: flex;
    align-items: flex-start;
    min-height: 640px;

    @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
    }

    @media only screen and (max-width: 640px) {
      min-height 520px
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      min-height: unset;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      min-height: 600px;
    }
  }
`;

export const PCMAContentStyles = css`
  ${PCMAWrapperStyles}.pcma-hero & {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    @media only screen and (min-width: ${themeGet('breakpoints.sm')}) {
      align-items: center;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      width: 50%;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      width: 100%;
    }
  }
`;

export const PCMATitleStyles = css`
  ${PCMAWrapperStyles}.pcma-hero & {
    font-size: 1.5rem;
    line-height: 2.5rem;

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      font-size: 2.25rem;
      line-height: 2.5rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      font-size: 2.5rem;
      line-height: 3.75rem;
    }

    sup {
      &:lang(fr) {
      }
    }
  }
`;

export const PCMAIntroStyles = css`
  ${PCMAWrapperStyles}.pcma-hero & {
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    }

    p {
      color: ${themeGet('colors.white')};

      @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      }

      @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      }
    }
  }
`;

export const PCMACTAWrapperStyles = css`
  ${PCMAWrapperStyles}.pcma-hero & {
  }
`;

export const PCMAMediaContainerStyles = css`
  ${PCMAWrapperStyles}.pcma-hero & {
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin: 0;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    }

    img {
      height: 100%;
    }
  }
`;

export const PCMAHeading = css`
  ${PCMAWrapperStyles}.pcma-hero & {
    text-align: center;
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      text-align: left;
    }
  }
`;
